import type { ReactNode } from 'react';
import styled from 'styled-components';

import { CenterFlex } from '@/components/base';
import ScrollView from '@/components/Common/ScrollView';
import Spinner from '@/components/Common/Spinner';
import Transition from '@/components/Common/Transition';

export const TabAsyncContentWrapper = ({
  status,
  children,
}: {
  status: boolean;
  children: ReactNode;
}) => {
  return (
    <Transition
      status={status}
      style={{
        flex: 1,
      }}
      fallback={
        <CenterFlex
          style={{
            height: 300,
          }}
        >
          <Spinner />
        </CenterFlex>
      }
    >
      {children}
    </Transition>
  );
};

export const TabContentStyle = styled(ScrollView).attrs({
  style: {
    height: 'calc(100vh - 242px)',
    padding: '10px 32px 32px 32px',
  },
})``;
